/**
 * TabNavigation Component
 *
 * Renders the tab navigation for the dev panel, allowing users
 * to switch between different sections.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {
    FiDatabase,
    FiSettings,
    FiClock,
    FiKey,
    FiUserCheck,
    FiLogIn
} from 'react-icons/fi';

const TabNavigation = ({ activeTab, onTabChange }) => {
    const tabs = [
        { id: 'organizations', label: 'Organizations', icon: FiDatabase },
        { id: 'impersonate', label: 'Impersonate', icon: FiLogIn },
        { id: 'settings', label: 'Settings', icon: FiSettings },
        { id: 'timebank', label: 'Time Bank', icon: FiClock },
        { id: 'auth', label: 'Auth', icon: FiKey },
        { id: 'roles', label: 'Roles', icon: FiUserCheck }
    ];

    return (
        <div className="dos-tabs">
            {tabs.map(tab => {
                const Icon = tab.icon;
                return (
                    <button
                        key={tab.id}
                        className={`dos-tab ${activeTab === tab.id ? 'dos-tab-active' : ''}`}
                        onClick={() => onTabChange(tab.id)}
                    >
                        <Icon />
                        {tab.label}
                    </button>
                );
            })}
        </div>
    );
};

TabNavigation.propTypes = {
    activeTab: PropTypes.oneOf(['organizations', 'impersonate', 'settings', 'timebank', 'auth', 'roles']).isRequired,
    onTabChange: PropTypes.func.isRequired
};

export default TabNavigation;
